import React from 'react'
import './not-found.scss'
import SinglePage from '../../components/common/page/SinglePage'
import Gif404 from '../../assets/images/404.gif'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

function NotFound() {
  const { user } = useSelector((state) => state.userAuth)
  const navigate = useNavigate()

  return (
    <div className='not-found-div'>
      <SinglePage>
        <div className="content-div">
          <div className="content">
            <div className="image">
              <img src={Gif404} alt="" />
              <h4>Page Not Found  : )</h4>
            </div>
            <div className="text">
              {user ?
                <button onClick={() => navigate('/')}>Home Page</button>
                :
                <button onClick={() => navigate('/login')}>Login</button>
              }
            </div>
          </div>
        </div>
      </SinglePage>
    </div>
  )
}

export default NotFound